module.exports = __webpack_public_path__ + "img/rotterdam.c0cdd636.jpg";